module.exports = __webpack_public_path__ + "frontend-assets/img/ab_plus_consent_small.cb03a35e.png";